import { createI18n } from 'vue-i18n';
import messages from '@intlify/unplugin-vue-i18n/messages';

export const LANGUAGE_LIST = ['fr', 'en', 'bre', 'it'] as const;
export type LanguageListValues = (typeof LANGUAGE_LIST)[number];

function getLanguage(): string {
  const lsLanguage = localStorage.getItem('locale');
  if (lsLanguage) return lsLanguage;
  const navigatorLanguage = navigator.language.split('-')[0];
  if (LANGUAGE_LIST.includes(navigatorLanguage.toLocaleLowerCase() as LanguageListValues))
    return navigatorLanguage;
  return import.meta.env.VITE_I18N_LOCALE || 'fr';
}

const i18n = createI18n({
  locale: getLanguage(),
  allowComposition: true,
  fallbackLocale: import.meta.env.VITE_I18N_LOCALE || 'fr',
  silentTranslationWarn: true,
  silentFallbackWarn: true,

  datetimeFormats: {
    fr: {
      timeShort: {
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    en: {
      timeShort: {
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    bre: {
      timeShort: {
        hour: 'numeric',
        minute: 'numeric',
      },
    },
    it: {
      timeShort: {
        hour: 'numeric',
        minute: 'numeric',
      },
    },
  },

  messages,
});

export default i18n;
